import React from 'react'

export const SliderForward = ({ circle = true }) => {
	return (
		<svg viewBox="0 0 48 48" version="1.1">
			<g
				id="Page-1"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				{circle && <circle id="Oval-Copy" fill="#FFFFFF" cx="24" cy="24" r="24"></circle>}
				<polyline
					id="Path-2"
					stroke="#000000"
					strokeWidth="2"
					points="21.859179 29.2134344 26.859179 24.2134344 21.859179 19.2134344"
				></polyline>
			</g>
		</svg>
	)
}
